<template>
  <div class="page-wrap">
    <!-- 顶部筛选与操作栏 -->
    <div class="search-wrap">
      <div class="search-form">
        <el-row :gutter="20">
          <el-col span="3">
            <el-form-item label="设备编号">
              <el-input v-model="search.equipCode" placeholder="请输入编号" />
            </el-form-item>
          </el-col>
          <el-col span="3">
            <el-form-item label="设备名称">
              <el-input v-model="search.equipName" placeholder="请输入名称" />
            </el-form-item>
          </el-col>
          <el-col span="3">
            <el-form-item label="设备类型">
              <el-select
                v-model="search.equipType"
                clearable
                placeholder="全部"
              >
                <el-option label="监测设备" value="monitor" />
                <el-option label="废气治理设备" value="wasteGas" />
                <el-option label="工艺设备" value="craft" />
                <el-option label="储罐设备" value="tank" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="3">
            <el-form-item label="所属车间">
              <el-select v-model="search.workshop" clearable placeholder="全部">
                <el-option label="一车间" value="work1" />
                <el-option label="二车间" value="work2" />
                <el-option label="储罐区" value="tankArea" />
                <el-option label="废气处理区" value="gasArea" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="3">
            <el-form-item label="运行状态">
              <el-select
                v-model="search.runStatus"
                clearable
                placeholder="全部"
              >
                <el-option label="正常运行" value="normal" />
                <el-option label="故障停机" value="fault" />
                <el-option label="停用" value="stop" />
                <el-option label="已报废" value="scrap" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="3">
            <el-form-item label="维保状态">
              <el-select
                v-model="search.mainStatus"
                clearable
                placeholder="全部"
              >
                <el-option label="维保正常" value="ok" />
                <el-option label="待维保" value="wait" />
                <el-option label="超期维保" value="over" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="4">
            <el-form-item label="投用时间">
              <el-date-picker
                v-model="search.useDate"
                type="daterange"
                range-separator="~"
                start-placeholder="开始"
                end-placeholder="结束"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="btn-group">
          <el-button
            type="primary"
            @click="queryTable"
            class="btn-primary-gradient"
            >查询</el-button
          >
          <el-button @click="resetSearch">重置</el-button>
          <el-button type="success" @click="openAddDialog">新增设备</el-button>
          <el-button @click="batchImport">批量导入台账</el-button>
          <el-button type="warning" @click="batchExport"
            >批量导出Excel/PDF</el-button
          >
          <el-button type="info" @click="printTable">打印台账</el-button>
        </div>
      </div>
    </div>

    <!-- 设备台账主表格 -->
    <div class="table-wrap">
      <el-table :data="tableData" border class="data-table">
        <!-- 基础信息 -->
        <el-table-column label="设备编号" prop="equipCode" width="120" />
        <el-table-column label="设备名称" prop="equipName" min-width="140" />
        <el-table-column label="设备分类" prop="equipType" width="110">
          <template #default="scope">
            <span>{{ getTypeName(scope.row.equipType) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="安装位置" prop="location" width="130" />
        <el-table-column label="设备型号" prop="model" width="120" />
        <el-table-column label="生产厂家" prop="factory" width="140" />
        <el-table-column label="出厂日期" prop="produceDate" width="110" />
        <el-table-column label="投用日期" prop="useDate" width="110" />
        <!-- 运行参数 -->
        <el-table-column label="额定参数" prop="ratedParam" width="140" />
        <el-table-column label="监测阈值" prop="threshold" width="100" />
        <el-table-column label="关联点位ID" prop="pointId" width="130" />
        <el-table-column label="运行状态" prop="runStatus" width="100">
          <template #default="scope">
            <el-tag :type="getStatusTag(scope.row.runStatus)">{{
              getStatusText(scope.row.runStatus)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="维保周期" prop="mainCycle" width="100" />
        <el-table-column label="下次维保时间" prop="nextMainDate" width="120" />
        <!-- 管理信息 -->
        <el-table-column label="责任人" prop="dutyUser" width="100" />
        <el-table-column label="联系方式" prop="phone" width="130" />
        <el-table-column label="设备照片" prop="imgUrl" width="90">
          <template #default="scope">
            <el-image
              v-if="scope.row.imgUrl"
              :src="scope.row.imgUrl"
              fit="cover"
              style="width: 40px; height: 40px"
              preview
            />
            <span v-else style="color: #7d92b8">无图</span>
          </template>
        </el-table-column>
        <el-table-column label="档案附件" prop="fileList" width="90">
          <template #default="scope">
            <el-link type="primary" @click="previewFile(scope.row)"
              >查看附件</el-link
            >
          </template>
        </el-table-column>
        <!-- 操作列 -->
        <el-table-column label="操作" width="300" fixed="right">
          <template #default="scope">
            <el-button size="small" @click="openEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="small"
              type="warning"
              @click="stopEquip(scope.row)"
              v-if="scope.row.runStatus !== 'stop'"
              >停用</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="scrapEquip(scope.row)"
              v-if="scope.row.runStatus !== 'scrap'"
              >报废</el-button
            >
            <el-button size="small" type="info" @click="openDetail(scope.row)"
              >档案详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增/编辑设备弹窗 -->
    <el-dialog
      v-model="dialogVisible"
      title="设备档案编辑"
      width="860"
      class="dark-dialog"
    >
      <el-form :model="formData" label-width="130px">
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="设备编号">
              <el-input v-model="formData.equipCode" :disabled="formData.id" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="设备名称">
              <el-input v-model="formData.equipName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="设备分类">
              <el-select v-model="formData.equipType">
                <el-option label="监测设备" value="monitor" />
                <el-option label="废气治理设备" value="wasteGas" />
                <el-option label="工艺设备" value="craft" />
                <el-option label="储罐设备" value="tank" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="所属车间">
              <el-select v-model="formData.workshop">
                <el-option label="一车间" value="work1" />
                <el-option label="二车间" value="work2" />
                <el-option label="储罐区" value="tankArea" />
                <el-option label="废气处理区" value="gasArea" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="安装位置">
              <el-input v-model="formData.location" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="设备型号">
              <el-input v-model="formData.model" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="生产厂家">
              <el-input v-model="formData.factory" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="出厂日期">
              <el-date-picker v-model="formData.produceDate" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="投用日期">
              <el-date-picker v-model="formData.useDate" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="额定参数">
              <el-input v-model="formData.ratedParam" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="监测阈值">
              <el-input v-model="formData.threshold" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="关联点位ID">
              <el-input v-model="formData.pointId" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="维保周期(天)">
              <el-input-number v-model="formData.mainCycle" min="1" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="下次维保时间">
              <el-date-picker v-model="formData.nextMainDate" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="责任人">
              <el-input v-model="formData.dutyUser" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="联系电话">
              <el-input v-model="formData.phone" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="设备照片上传">
          <el-upload action="#" list-type="picture-card">
            <template #default>
              <i class="el-icon-plus"></i>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item label="档案附件上传">
          <el-upload action="#" multiple>
            <el-button type="primary">选择PDF/Word/图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注说明">
          <el-input v-model="formData.remark" type="textarea" rows="3" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveForm">保存设备档案</el-button>
      </template>
    </el-dialog>

    <!-- 设备档案详情弹窗 -->
    <el-dialog
      v-model="detailVisible"
      title="设备完整档案详情"
      width="920"
      class="dark-dialog"
    >
      <div class="detail-box" v-if="currRow">
        <div class="detail-title">基础设备信息</div>
        <div class="detail-row">
          <div class="detail-item">
            <label>设备编号：</label>{{ currRow.equipCode }}
          </div>
          <div class="detail-item">
            <label>设备名称：</label>{{ currRow.equipName }}
          </div>
          <div class="detail-item">
            <label>设备分类：</label>{{ getTypeName(currRow.equipType) }}
          </div>
          <div class="detail-item">
            <label>运行状态：</label
            ><el-tag :type="getStatusTag(currRow.runStatus)">{{
              getStatusText(currRow.runStatus)
            }}</el-tag>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <label>安装位置：</label>{{ currRow.location }}
          </div>
          <div class="detail-item">
            <label>型号：</label>{{ currRow.model }}
          </div>
          <div class="detail-item">
            <label>厂家：</label>{{ currRow.factory }}
          </div>
          <div class="detail-item">
            <label>出厂日期：</label>{{ currRow.produceDate }}
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <label>投用日期：</label>{{ currRow.useDate }}
          </div>
          <div class="detail-item">
            <label>额定参数：</label>{{ currRow.ratedParam }}
          </div>
          <div class="detail-item">
            <label>监测阈值：</label>{{ currRow.threshold }}
          </div>
          <div class="detail-item">
            <label>关联点位：</label>{{ currRow.pointId }}
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <label>维保周期：</label>{{ currRow.mainCycle }}天
          </div>
          <div class="detail-item">
            <label>下次维保：</label>{{ currRow.nextMainDate }}
          </div>
          <div class="detail-item">
            <label>责任人：</label>{{ currRow.dutyUser }}
          </div>
          <div class="detail-item">
            <label>联系方式：</label>{{ currRow.phone }}
          </div>
        </div>
        <div class="detail-title" style="margin-top: 20px">附件与照片</div>
        <div class="file-area">
          <el-image
            v-if="currRow.imgUrl"
            :src="currRow.imgUrl"
            style="width: 120px; height: 120px"
            preview
          />
          <div v-else class="no-file">无设备实拍照片</div>
          <div style="margin-left: 20px">
            <div v-if="currRow.fileList?.length">
              附件列表：
              <div v-for="f in currRow.fileList" :key="f">{{ f }}</div>
            </div>
            <div v-else class="no-file">暂无档案附件</div>
          </div>
        </div>
        <div class="detail-title" style="margin-top: 20px">档案备注</div>
        <div class="remark-text">{{ currRow.remark || "无备注信息" }}</div>
      </div>
      <template #footer>
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button type="primary" @click="openEditDialog(currRow)"
          >编辑档案</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="js">
import { ref, reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'

// 分页
const pageNum = ref(1)
const tableTotal = ref(68)

// 搜索条件
const search = reactive({
  equipCode: '',
  equipName: '',
  equipType: '',
  workshop: '',
  runStatus: '',
  mainStatus: '',
  useDate: []
})

// 表格模拟数据
const tableData = ref([
  {
    id: 1,
    equipCode: 'GDS-001',
    equipName: '4#装置气体探测器',
    equipType: 'monitor',
    location: '4#装置废气区',
    model: 'GD-800',
    factory: '安环检测设备厂',
    produceDate: '2024-03-12',
    useDate: '2024-04-01',
    ratedParam: '0-100%LEL',
    threshold: 20,
    pointId: 'P0042',
    runStatus: 'normal',
    mainCycle: 90,
    nextMainDate: '2026-10-01',
    dutyUser: '张工',
    phone: '13800112233',
    imgUrl: '',
    fileList: ['设备合格证.pdf','维保记录.docx'],
    remark: '日常连续在线监测设备'
  },
  {
    id: 2,
    equipCode: 'VOC-005',
    equipName: '车间VOC在线监测仪',
    equipType: 'wasteGas',
    location: '一车间尾气排放口',
    model: 'VOC2000',
    factory: '环保科技有限公司',
    produceDate: '2023-11-05',
    useDate: '2023-12-10',
    ratedParam: '0-200mg/m³',
    threshold: 60,
    pointId: 'P0105',
    runStatus: 'wait',
    mainCycle: 60,
    nextMainDate: '2026-07-30',
    dutyUser: '李运维',
    phone: '13900223344',
    imgUrl: '',
    fileList: [],
    remark: '下月到期维保'
  },
  {
    id: 3,
    equipCode: 'TANK-002',
    equipName: '原料储罐液位计',
    equipType: 'tank',
    location: '储罐区2号罐',
    model: 'LT-90',
    factory: '仪表设备公司',
    produceDate: '2022-06-20',
    useDate: '2022-07-01',
    ratedParam: '0-10m',
    threshold: 8.5,
    pointId: 'P0201',
    runStatus: 'fault',
    mainCycle: 120,
    nextMainDate: '2026-08-15',
    dutyUser: '王主管',
    phone: '13700334455',
    imgUrl: '',
    fileList: ['检修报告.pdf'],
    remark: '当前液位探头故障停机'
  }
])

// 新增编辑弹窗
const dialogVisible = ref(false)
const formData = reactive({
  id: '',
  equipCode: '',
  equipName: '',
  equipType: '',
  workshop: '',
  location: '',
  model: '',
  factory: '',
  produceDate: '',
  useDate: '',
  ratedParam: '',
  threshold: '',
  pointId: '',
  mainCycle: 90,
  nextMainDate: '',
  dutyUser: '',
  phone: '',
  imgUrl: '',
  fileList: [],
  remark: '',
  runStatus: 'normal'
})

// 详情弹窗
const detailVisible = ref(false)
const currRow = ref(null)

// 类型文字转换
const getTypeName = (val) => {
  const map = {
    monitor: '监测设备',
    wasteGas: '废气治理设备',
    craft: '工艺设备',
    tank: '储罐设备'
  }
  return map[val] || val
}
// 状态文字与标签
const getStatusText = (val) => {
  const map = { normal: '正常运行', fault: '故障停机', stop: '停用', scrap: '已报废' }
  return map[val] || val
}
const getStatusTag = (val) => {
  const map = { normal: 'success', fault: 'danger', stop: 'info', scrap: '' }
  return map[val] || ''
}

// 查询
const queryTable = () => {
  ElMessage.success('查询完成')
  pageNum.value = 1
}
// 重置
const resetSearch = () => {
  Object.assign(search, {
    equipCode: '',equipName:'',equipType:'',workshop:'',runStatus:'',mainStatus:'',useDate:[]
  })
}
// 新增弹窗
const openAddDialog = () => {
  dialogVisible.value = true
  Object.assign(formData, {
    id:'',equipCode:'',equipName:'',equipType:'',workshop:'',location:'',model:'',factory:'',
    produceDate:'',useDate:'',ratedParam:'',threshold:'',pointId:'',mainCycle:90,
    nextMainDate:'',dutyUser:'',phone:'',imgUrl:'',fileList:[],remark:'',runStatus:'normal'
  })
}
// 编辑弹窗
const openEditDialog = (row) => {

  dialogVisible.value = true
  Object.assign(formData, row)
}
// 保存表单
const saveForm = () => {
  ElMessage.success(formData.id ? '设备档案修改成功' : '新增设备台账完成')
  dialogVisible.value = false
}
// 停用设备
const stopEquip = (row) => {
  ElMessageBox.confirm(`确认将【${row.equipName}】设为停用状态？`).then(()=>{
    row.runStatus = 'stop'
    ElMessage.success('状态已更新')
  })
}
// 报废设备
const scrapEquip = (row) => {
  ElMessageBox.confirm(`确认报废【${row.equipName}】，报废后不可恢复？`).then(()=>{
    row.runStatus = 'scrap'
    ElMessage.success('设备已标记报废')
  })
}
// 批量导入
const batchImport = () => ElMessage.info('打开Excel导入弹窗')
// 批量导出
const batchExport = () => ElMessage.success('台账文件导出成功')
// 打印
const printTable = () => ElMessage.info('唤起打印预览')
// 打开详情
const openDetail = (row) => {
  currRow.value = row
  detailVisible.value = true
}
// 预览附件
const previewFile = () => ElMessage.info('打开文件预览弹窗')
</script>

<style lang="scss" scoped>
/* 顶部筛选栏 */
.search-wrap {
  background: var(--bg-search);
  border: 1px solid rgba(64, 158, 255, 0.22);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
}
.search-form {
  .el-form-item label {
    color: var(--text-sub);
  }
}
.btn-group {
  margin-top: 16px;
  display: flex;
  gap: 12px;
}
.btn-primary-gradient {
  background: var(--grad-blue);
  border: none;
}
/* 表格区域 */
.table-wrap {
  width: 100%;
}

.dark-page :deep(.el-pagination) {
  color: var(--text-sub);
}
/* 弹窗深色 */
.dark-dialog :deep(.el-dialog) {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
}
.dark-dialog :deep(.el-dialog__title) {
  color: #fff;
}
.dark-dialog :deep(.el-form-item label) {
  color: var(--text-sub);
}
/* 详情弹窗样式 */
.detail-box {
  color: var(--text-sub);
}
.detail-title {
  font-size: 16px;
  color: #fff;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(64, 158, 255, 0.2);
  margin-bottom: 12px;
}
.detail-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 10px;
}
.detail-item label {
  color: #94b8d9;
  margin-right: 6px;
}
.file-area {
  display: flex;
  align-items: center;
}
.no-file {
  color: #7d92b8;
}
.remark-text {
  line-height: 1.6;
}
</style>
